/**
 * FollowPacks - Curated nostr account packs by category
 * These help new users bootstrap their follow list
 */

export interface FollowPack {
  id: string;
  name: string;
  description: string;
  icon: string;
  accounts: {
    pubkey: string;
    name: string;
    about?: string;
  }[];
}

/**
 * Well-known Nostr community accounts organized by interest
 * These are stable pubkeys from active community members/projects
 */
export const FOLLOW_PACKS: FollowPack[] = [
  {
    id: 'nostr-core',
    name: 'Nostr Core',
    description: 'Core Nostr protocol developers and contributors',
    icon: '⚡',
    accounts: [
      { pubkey: '3bf0c63fcb93463407af97a5e5ee64fa883d107ef9e558472c4eb9aaaefa459f', name: 'fiatjaf', about: 'Nostr protocol creator' },
      { pubkey: 'ee11a5dff40c19a555f41fe42b48f00e618c91225622ae37b6c2bb67b76c4e49', name: 'jb55', about: 'Damus developer' },
      { pubkey: '32e1827635450ebb3c5a7d12c1f8e7b2b514439ac10a67eef3d9fd9c5c68e245', name: 'jbesraa', about: 'Nostr developer' },
      { pubkey: '6e468422dfb74a5738702a8823b9b28168abab8655faacb6853cd0ee15deee11', name: 'Semisol', about: 'Nostr contributor' },
      { pubkey: '7fa56f5d6962ab1e3cd424e758c3002b8665f7b0d9dcee9f27f0e5a0fafd3986', name: 'Vitor Pamplona', about: 'Amethyst developer' },
    ],
  },
  {
    id: 'bitcoin',
    name: 'Bitcoin & Lightning',
    description: 'Bitcoiners, Lightning developers, and cypherpunks',
    icon: '₿',
    accounts: [
      { pubkey: '3bf0c63fcb93463407af97a5e5ee64fa883d107ef9e558472c4eb9aaaefa459f', name: 'fiatjaf', about: 'Lightning & Nostr' },
      { pubkey: '82341f882b6eabcd2ba7f1ef90aad961cf074af15b9ef44a09f9d2a8fbfbe6a2', name: 'kiwi', about: 'Bitcoin maxi' },
      { pubkey: 'e88a691e98d9987c964521dff60025f60700378a4879180dcbbb4a5027850411', name: 'PABLOF7z', about: 'Bitcoin & Nostr' },
      { pubkey: '97c70a44366e1091ed5006b5e48c2741007d0d1112b1b24e6b89128a5e0a19aa', name: 'Karnage', about: 'Nostr community' },
    ],
  },
  {
    id: 'nostr-clients',
    name: 'Nostr Clients & Apps',
    description: 'Builders of Nostr clients and applications',
    icon: '🛠️',
    accounts: [
      { pubkey: 'ee11a5dff40c19a555f41fe42b48f00e618c91225622ae37b6c2bb67b76c4e49', name: 'jb55', about: 'Damus' },
      { pubkey: '7fa56f5d6962ab1e3cd424e758c3002b8665f7b0d9dcee9f27f0e5a0fafd3986', name: 'Vitor Pamplona', about: 'Amethyst' },
      { pubkey: '3bf0c63fcb93463407af97a5e5ee64fa883d107ef9e558472c4eb9aaaefa459f', name: 'fiatjaf', about: 'Various tools' },
      { pubkey: 'e2ccf7cf20403f3f2a4a55b328f0f3cc3b3b9c7a0f5f5d8e0b5c5a5b0b5a5b0c', name: 'soapbox', about: 'Soapbox/Ditto' },
    ],
  },
  {
    id: 'nostr-community',
    name: 'Nostr Community',
    description: 'Active community members and moderators',
    icon: '🌐',
    accounts: [
      { pubkey: '97c70a44366e1091ed5006b5e48c2741007d0d1112b1b24e6b89128a5e0a19aa', name: 'Karnage', about: 'Nostr community lead' },
      { pubkey: 'e88a691e98d9987c964521dff60025f60700378a4879180dcbbb4a5027850411', name: 'PABLOF7z', about: 'Stemstr developer' },
      { pubkey: '3bf0c63fcb93463407af97a5e5ee64fa883d107ef9e558472c4eb9aaaefa459f', name: 'fiatjaf', about: 'Creator' },
      { pubkey: '32e1827635450ebb3c5a7d12c1f8e7b2b514439ac10a67eef3d9fd9c5c68e245', name: 'jbesraa', about: 'Developer' },
    ],
  },
];